import { createFileRoute } from "@tanstack/react-router";
import AdminMenu from "@/pages/admin/AdminMenu";

export const Route = createFileRoute("/_adminLayout/admin/menu")({
  component: AdminMenu,
});
